import React, { useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { ColorPicker, ColorPickerChangeEvent } from 'primereact/colorpicker';
import './AdaptiveColorPicker.scss';

interface Props {
  value: string;
  onChange: (color: string) => void;
  disabled: boolean;
  id?: string;
}

export const AdaptiveColorPicker = ({ value, onChange, disabled, id }: Props) => {
  const nativeInputRef = useRef<HTMLInputElement>(null);
  const isTouchDevice = Capacitor.isNativePlatform() || window.matchMedia('(hover: none)').matches;

  const handleNativeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleWebChange = (e: ColorPickerChangeEvent) => {
    onChange(`#${e.value as string}`);
  };

  if (isTouchDevice) {
    return (
      <div className='adaptive-color-picker native' onClick={() => !disabled && nativeInputRef.current?.click()}>
        <span className='color-swatch' style={{ backgroundColor: value }} />
        <input
          ref={nativeInputRef}
          id={id}
          type='color'
          value={value}
          onChange={handleNativeChange}
          disabled={disabled}
          className='native-color-input'
        />
      </div>
    );
  }

  return <ColorPicker id={id} format='hex' value={value.replace('#', '')} onChange={handleWebChange} disabled={disabled} />;
};
